type TruthyValue<T> = Exclude<T, null | undefined | 0 | "" | false>;
export const booleanFilter = <T,>(x: T): x is TruthyValue<T> => Boolean(x);